<template>
	<v-dialog :fullscreen="isMobile" v-if="open" v-model="open" max-width="700px" scrollable>
		<v-card raised>
				<v-card-title>
					<button type="button" class="btn-flat-icon--dark" @click="open=false">
						<v-icon medium flat>fal fa-times</v-icon>
					</button>
				</v-card-title>
				<v-card-text class="pt-0 event-page__modal-card-text">
					<div>
						<p class="event-page__modal-heading">Contact Guest</p>
						<v-divider class="mt-3 mb-3"></v-divider>
						<form>
							<v-textarea
								color="link"
								v-model="contactGuestMessage"
								label="Message"
								rows="5"
								required
								validate-on-blur
							></v-textarea>
						</form>
					</div>
					<div style="display: flex; flex-direction: row; justify-content: flex-end;">
						<v-btn class="btn-blue" @click="sendContactGuestEmail">Send Message</v-btn>
					</div>
				</v-card-text>
			</v-card>
	</v-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import axios from 'axios'
export default {
	name: 'eventContactGuestModal',
	data() {
		return {
			contactGuestMessage: ''
		}
	},
	methods: {
		...mapActions(['setModalOpen', 'setSnackbarText', 'setSnackbarOpen']),
		sendContactGuestEmail() {
			let recipient = null
			recipient = this.getModalProp('eventGuestModalIndex')
			axios
				.post('/api/v1/contact/', {
					name: this.user.first_name + ' ' + this.user.last_name,
					subject: 'Message from host of ' + this.event.title,
					event: this.event.pk,
					recipient: recipient,
					message: this.contactGuestMessage,
					email: this.user.email
				})
				.then(response => {
					this.resetContactModal()
					this.setSnackbarText('Message Sent!')
					this.setSnackbarOpen(true)
				})
		},
		resetContactModal() {
			this.open = false
			this.contactGuestMessage = ''
		}
	},
	computed: {
		...mapGetters(['getModalProp', 'user']),
		host() {
			return this.event.host.user
		},
		open: {
			get() {
				return this.getModalProp('eventContactGuestModal')
			},
			set(val) {
				this.setModalOpen({ prop: 'eventContactGuestModal', value: val })
			}
		},
		event() {
			return this.getModalProp('eventModalEvent')
		},
		isMobile() {
			if (this.$vuetify.breakpoint.name === 'xs') {
				return true
			} else {
				return false
			}
		}
	}
}
</script>
